export class ScheduleLayer {
    schdLayerNo: number;
    schdNo: number;
    aplyTxnNo: number;
    tmznCd: string;
    statCd: string;
    mappCnfgCnt: number;
    aplyOrdrNo: number;
    aplyStDt: string;
    aplyEndDt: string;
    rotnTypeCd: string;
    intvUnitCd: string;
    shftTimeVal: string;
    notificationLimit = {
        useFlag : false,
        type: 'day',
        dayData: [],
        weekData: []};

constructor(values: {
        schdLayerNo?: number,
        schdNo?: number,
        aplyTxnNo?: number,
        tmznCd?: string,
        statCd?: string,
        mappCnfgCnt?: number,
        aplyOrdrNo?: number,
        aplyStDt?: string,
        aplyEndDt?: string,
        rotnTypeCd?: string,
        intvUnitCd?: string,
        shftTimeVal?: string,
        notificationLimit?: object
    } = {}) {
        this.schdLayerNo = values.schdLayerNo || null;
        this.schdNo = values.schdNo || null;
        this.aplyTxnNo = values.aplyTxnNo || null;
        this.tmznCd = values.tmznCd || null;
        this.statCd = values.statCd || null;
        this.mappCnfgCnt = values.mappCnfgCnt || null;
        this.aplyOrdrNo = values.aplyOrdrNo || null;
        this.aplyStDt = values.aplyStDt || null;
        this.aplyEndDt = values.aplyEndDt || null;
        this.rotnTypeCd = values.rotnTypeCd || null;
        this.intvUnitCd = values.intvUnitCd || null;
        this.shftTimeVal = values.shftTimeVal || null;
        this.notificationLimit.useFlag = values.notificationLimit['useFlag'] || false;
        this.notificationLimit.type = values.notificationLimit['type'] || 'day';
        this.notificationLimit.dayData = values.notificationLimit['dayData'] || [];
        this.notificationLimit.weekData = values.notificationLimit['weekData'] || [];
    }
}


export class DefaultLayerValue {
    shftTimeVal = '09:00';
    shftDfwCd = 'MON';
    aplyStDt = '2019-02-01 09:00';
    aplyStDt_temp = {
        date : '2019-02-01',
        time: '09:00'
    };
    onCallCnfgStTime = '00:00';
    onCallCnfgEndTime = '01:00';
    constructor(aplyStDt?, aplyStTime?) {
        this.shftTimeVal = aplyStTime || '01:00';
        this.aplyStDt = `${aplyStDt} ${aplyStTime}` || '2019-01-01 01:00';
        this.aplyStDt_temp = {
            date : aplyStDt || '2019-01-01',
            time: aplyStTime || '01:00'
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/src/schedule/schedule.layer.ts